module.exports = __webpack_public_path__ + "media/icons/expand-height-8aeb1467.svg";